



































import { Vue, Component, Prop } from 'vue-property-decorator';
import { EButtonTypes } from '@lib-shared/enums/ButtonType';
import Button from '@/components/Button.vue';
import UploadFileButton from '@/components/UploadFileButton.vue';

@Component({
  components: {
    UploadFileButton,
    Button,
  },
  data: () => ({
    EButtonTypes,
  }),
})
export default class UploadModal extends Vue {
  @Prop() requestedFileName: string;
  @Prop() acceptedFileTypes?: string[];
  @Prop() headerText?: string;
  @Prop() subHeaderText?: string;

  file: File = null;

  get fileName(): string {
    if (!this.file) {
      return '';
    }
    return this.file.name;
  }

  handleSelectFile(file: File) {
    this.file = file;
  }

  handleClose() {
    this.$emit('close');
  }

  async handleUpload() {
    this.$emit('upload', this.file);
    this.handleClose();
  }
}
